import React from "react";
import CacheBuster from "react-cache-buster";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";
import ErrorBoundary from "./components/pages/errors/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import Loader from "./components/reusables/Loader";
import pkg from "../package.json";
import "./index.css";
import "./polyfills";
import { store, persistor } from "./app/store";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={true}
      isVerboseMode={true}
      loadingComponent={<Loader />}
    >
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </CacheBuster>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
